import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading tracking-tight">
            GTBuy<span className="text-primary-400">Spreadsheet</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <p className="text-sm text-foreground-300 leading-relaxed max-w-sm">
              GTBuy Spreadsheet is the trusted sourcing and order management tool for resellers worldwide. Compare products, track inventory, and grow your ecommerce business with confidence.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" aria-label="Twitter" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 hover:border-primary-400 hover:text-primary-400 transition-colors duration-200">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" aria-label="Instagram" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 hover:border-primary-400 hover:text-primary-400 transition-colors duration-200">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" aria-label="YouTube" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 hover:border-primary-400 hover:text-primary-400 transition-colors duration-200">
                <i className="ri-youtube-line text-sm"></i>
              </a>
              <a href="#" aria-label="LinkedIn" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-700 hover:border-primary-400 hover:text-primary-400 transition-colors duration-200">
                <i className="ri-linkedin-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-5">
            <div className="grid grid-cols-2 gap-8">
              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Quick Links</h4>
                <div className="space-y-2.5">
                  <Link to="/" className="block text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap">Home</Link>
                  <Link to="/guide/gtbuy-sheet-guide" className="block text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap">GTBuy Sheet Guide</Link>
                  <Link to="/guide/gtbuy-sheet-guide" className="block text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap">Shopping Guide</Link>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    KA Spreadsheet
                    <span className="w-3 h-3 inline-flex items-center justify-center ml-1">
                      <i className="ri-arrow-right-up-line text-[10px]"></i>
                    </span>
                  </a>
                </div>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-4">Categories</h4>
                <div className="space-y-2.5 max-h-[200px] overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block text-sm text-foreground-300 hover:text-white transition-colors duration-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="w-full aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20of%20a%20woven%20straw%20market%20tote%20bag%20on%20a%20light%20sand%20surface%20with%20soft%20natural%20shadows%2C%20warm%20earthy%20neutral%20tones%2C%20airy%20bright%20composition%2C%20editorial%20fashion%20still%20life%2C%20simple%20elegant%20aesthetic&width=400&height=533&seq=footer-img-v3&orientation=portrait"
                alt="GTBuy Spreadsheet featured product"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            &copy; {new Date().getFullYear()} GTBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">Home</Link>
            <Link to="/guide/gtbuy-sheet-guide" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">Guide</Link>
            <Link to="/guide/gtbuy-sheet-guide" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">Shopping Guide</Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">KA Spreadsheet</a>
          </div>
        </div>
      </div>
    </footer>
  );
}